var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaotomeandprincipe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30434 7.82611H23.2536C21.5581 3.2565 17.1595 0 12 0C8.68622 0 5.68655 1.34339 3.51511 3.51511L7.30434 7.82611Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30434 16.1739H23.2536C21.5581 20.7435 17.1595 24 12 24C8.68622 24 5.68655 22.6566 3.51511 20.4849L7.30434 16.1739Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51469 3.51469C-1.17159 8.20097 -1.17159 15.799 3.51469 20.4853C5.45123 18.5488 7.31372 16.6863 12 12L3.51469 3.51469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2378 9.91302L15.7559 11.5073H17.4322L16.076 12.4927L16.594 14.087L15.2378 13.1016L13.8817 14.087L14.3996 12.4927L13.0435 11.5073H14.7198L15.2378 9.91302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4553 9.91302L20.9732 11.5073H22.6496L21.2934 12.4927L21.8114 14.087L20.4553 13.1016L19.099 14.087L19.617 12.4927L18.2609 11.5073H19.9372L20.4553 9.91302Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaotomeandprincipe);
export default __webpack_public_path__ + "static/media/saotomeandprincipe.08fb982c55426b1abae883816b69f041.svg";
export { ForwardRef as ReactComponent };